module.exports = __webpack_public_path__ + "static/stamp-white-1542209ef1dce9afe9811083000fa994.svg";